const memberNav = () => {
	const memberAside = document.querySelector('.member-aside');
	const memberCollapse = document.querySelector('.member-collapse');
	// const memberNav = document.querySelector('.member-nav');

	if (!memberAside || !memberCollapse) {
		return;
	}

	memberCollapse.addEventListener('click', (event) => {
		event.preventDefault();
		memberAside.classList.toggle('is-active');
		memberCollapse.setAttribute('aria-expanded', memberAside.classList.contains('is-active'));
	});

}

export { memberNav };
